<template>
    <el-popover
        placement="bottom-end"
        :width="popverWidth"
        trigger="focus"
        size="small"
        @show="showChooseData"
        v-model="isShowTreeData">
        <el-tree
            ref="elTree"
            :data="treeData"
            node-key="id"
            :default-expand-all="isExpand"
            :default-expanded-keys="expandedData"
            :props="defaultProps"
            accordion
            @node-click="clickClassNode"
            :filter-node-method="filterNode"
            style="max-height: 160px;overflow-y: auto;">
        </el-tree>
        <el-input slot="reference"
            ref="serachInput" 
            v-model="inputContent" size="small" 
            :placeholder="placeholder"
            @focus="clickInput"
            @blur="hidePopver">
            <i slot="suffix" class="el-input__icon" :class="hasVal?'el-icon-circle-close':'el-icon-arrow-down'"
                @click="clickInputIcon"></i>
            </el-input>
    </el-popover>
</template>
<script>
import * as mClassData from '../../data/materialClass.js';
export default {
    props: {
      placeholder: {
        type: String,
        default: ''
      }
    },
    data() {
        return {
            inputContent: '',//输入框数据
            isShowTreeData: false,//是否显示弹框
            allData: [],//所有数据,预留
            treeData: [],//选择树数据
            expandedData: [],//需要展开的数据
            //tree 默认参数
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            //选择后的参数
            choosedMaterial:{
                grandpaId: '',
                grandpaName: '',
                parentId: '',
                parentName: '',
                name: '',
                id: "",
            },
            //弹框宽度
            popverWidth: '260',
            //是否展开
            isExpand:false,
            //输入框是否有值
            hasVal: false
        };
    },
    created() {
        // this.treeData  = mClassData.default;
    },
    
    watch: {
        inputContent(val) {
            //输入框内容监听,方便实时过滤
            let inputVal = [];
            if (val.indexOf('-') > -1) {
                inputVal = val.split('-')
            }
            let valueStr = '';
            if (inputVal.length > 0) {
                valueStr = inputVal[inputVal.length-1];
            } else {
                valueStr = val
            }

            if (val && val.length > 0) {
                this.hasVal = true;
            } else {
                this.expandedData = [];
                this.hasVal = false;
            }
            this.$refs.elTree.filter(valueStr);
            
        }
    },
    methods: {
        //初始化输入框内容
        initInputVal(value) {
            this.inputContent = value;
        },
        //清空输入框内容
        clearInputVal() {
            this.inputContent = '';
        },
        //点击输入框右侧图标
        clickInputIcon() {
            if (this.inputContent) {
                this.inputContent = '';
                // this.isShowTreeData = false;
            }
            this.$emit('clearInput');
        },
        //点击输入框时间
        clickInput() {
            this.isShowTreeData = true;
        },
        //隐藏弹框
        hidePopver() {
            // this.isShowTreeData = false;
        },
        //数据初始化方法调用
        initData(data) {
            this.treeData = data;
            this.allData = data;
        },
        //弹框显示时间回调
        showChooseData() {
            let inputWidth = this.$refs.serachInput.$el.offsetWidth-24;
            this.popverWidth = inputWidth.toString();
            if (!this.inputContent) {
                this.expandedData = [];
            }
        },
        //数据筛选
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },
        //选择数据
        clickClassNode(data, node, event) {
            // this.$refs.serachInput.focus();
            //判断是否存在子集
            if (data.children && data.children.length > 0) {
                return false;
            } else {
                //若不存在，则处理数据
                let objData = [];
                this.choosedMaterial.name = node.label;
                objData.push({
                    id: data.id,
                    name: data.label,
                    level: node.level
                });
                let valCon = data.label
                let parent = node.parent;
                for(let i = node.level;i>=0;i--) {
                    if (parent) {
                        if (parent.data.id) {
                            objData.push({
                                id: parent.data.id,
                                name: parent.data.label,
                                level: parent.level
                            });
                            valCon = parent.data.label+'-'+valCon;
                        }
                        parent = parent.parent;
                    }
                }
                this.inputContent = valCon;
                this.expandedData = [];
                this.isShowTreeData = false;
                this.expandedData[0]=data.id;
                //事件传送  调用时@chooseData="自定义方法"，出参{id:'',name:'',level:''}
                this.$emit('chooseData', objData);
            }
        }
    }
}
</script>
